// src/pages/LoginPage.jsx
// Màn hình đăng nhập với Google

import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import toast from "react-hot-toast";
import "../styles/login.css";

export default function LoginPage() {
  const { user, loading, signInWithGoogle } = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);

  // Đã đăng nhập rồi → về dashboard
  if (!loading && user) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleGoogleSignIn = async () => {
    setIsSigningIn(true);
    const result = await signInWithGoogle();

    if (!result.success) {
      toast.error("Đăng nhập thất bại. Vui lòng thử lại.");
      setIsSigningIn(false);
    }
    // Nếu thành công, onAuthStateChanged tự điều hướng
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo / Brand */}
        <div className="login-brand">
          <div className="brand-icon">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="10" fill="currentColor" opacity="0.12"/>
              <path d="M8 11h10M8 16h16M8 21h7" stroke="currentColor" strokeWidth="2.2"
                strokeLinecap="round"/>
              <circle cx="24" cy="11" r="3" fill="currentColor"/>
            </svg>
          </div>
          <h1 className="brand-name">TeamTodo</h1>
        </div>

        <div className="login-content">
          <h2 className="login-title">Chào mừng trở lại</h2>
          <p className="login-subtitle">
            Quản lý công việc nhóm dễ dàng hơn bao giờ hết.
          </p>

          <button
            className="google-btn"
            onClick={handleGoogleSignIn}
            disabled={isSigningIn || loading}
          >
            {isSigningIn ? (
              <span className="btn-spinner" />
            ) : (
              <GoogleIcon />
            )}
            <span>
              {isSigningIn ? "Đang đăng nhập..." : "Tiếp tục với Google"}
            </span>
          </button>

          <p className="login-note">
            Bằng cách đăng nhập, bạn đồng ý với{" "}
            <a href="#">Điều khoản sử dụng</a> của chúng tôi.
          </p>
        </div>
      </div>

      {/* Background decoration */}
      <div className="login-bg">
        <div className="bg-blob bg-blob-1" />
        <div className="bg-blob bg-blob-2" />
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}
